import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Card,
  CardBody,
  Heading,
  Text,
} from '@chakra-ui/react';

const OrganizationNotesSection = ({ notes }) => (
  <Card>
    <CardBody p={0}>
      <Accordion allowToggle>
        <AccordionItem border="none">
          <AccordionButton py={4} px={6} _expanded={{ bg: 'gray.50' }}>
            <Box flex="1" textAlign="left">
              <Heading size="md">General Notes</Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={5} px={6}>
            {notes ? (
              <Text whiteSpace="pre-wrap">{notes}</Text>
            ) : (
              <Text color="gray.500" fontStyle="italic">There are no notes for this school yet.</Text>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </CardBody>
  </Card>
);

export default OrganizationNotesSection;
